<template>
  <div class>
    <el-dialog title width="500px" class="repair-dialog" :visible.sync="dialogHide" :before-close="handleClose" center>
      <div class="p10">
        <p class="money">{{ hintName ? hintName : '支付成功' }}</p>
        <div class="success-text">
          <p v-if="amount">
            共计消耗<span class="moneys">{{amount}}</span> 积分
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn small-btn" @click="gotoOrderInfo">查看详情</el-button>
        <el-button class="btn small-btn" type="primary" @click="gotoProductFootBath">返回主页</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    hintName: {
      type: String,
      default: null
    },
    amount: {
      type: Number,
      default: null
    },
    orderId: {
      type: String,
      default: null
    },
    foot: {
      type: Boolean,
      default: false
    },
    meal: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      form: {},
      id: "",
      dialogHide: false,
      payWayList: [],
      parentForm: {},
      isPayWayHide: true,
      mainHeight: this.$store.getters.MainHeight,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    handleClose() {
      this.$router.push(`/dataList/integralOrder`);
    },
    init() {
      this.$on("set", function(id) {
        console.log(id);
        this.id = id;
        this.dialogHide = true;
      });
    },
    gotoOrderInfo() {
      // 跳转兑换详情
      localStorage.setItem("integralId", this.orderId)
      this.$router.push(`/dataList/integralOrder`);
    },
    gotoProductFootBath() {
      this.$router.push(`/dataList/integralOrder`);
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 261px;
  top: calc(50% - 130px);
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  height: 50px;
  box-sizing: border-box;
  padding: 0;
  line-height: 50px;
  text-align: center;
  font-size: 0.18rem;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 13px;
    .el-dialog__close {
      color: #666;
      font-size: 0.18rem;
      border: 1px solid #666;
      border-radius: 50%;
      padding: 2px;
      &:hover {
        color: @blue;
        border: 1px solid @blue;
        background: #fff;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding: 0;
  display: flex;
  justify-content: center;
  height: auto !important;
  .money {
    font-size: 16px;
    color: @blue;
    font-weight: 500;
    text-align: center;
    position: absolute;
    top: 35px;
    left: 50%;
    margin-left: -32px;
  }
  .success-text {
    width: 325px;
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
    padding-bottom: 18px;
    border-bottom: 1px solid @borderColor;
    text-align: center;
    span {
      color: @money;
    }
  }
}

/deep/ .el-dialog__footer {
  text-align: center;
  margin-top: 43px;
  .btn {
    font-size: 0.18rem;
    // width: 155px;
    // height: 55px;
  }
  .normal-btn {
    margin-right: 50px;
  }
}
</style>